// extracted by mini-css-extract-plugin
export var sitemap = "section-sitemap-module--sitemap--0125b";
export var sitemapContainer = "section-sitemap-module--sitemap-container--bea84";
export var sitemapTitle = "section-sitemap-module--sitemap-title--05b64";